import Storage from '@/utils/storage'
import { resetRouter } from '@/router'
import store from '@/store'

/*
const generateToken = (val) => {
  return SHA256.hash(val)
}
*/

const initUserInfo = () => {
  return Object.assign({}, {
    userId: null,
    login: '',
    netId: '',
    userGender: '',
    userEmail: '',
    userFirstName: '',
    userLastName: '',
    phoneNumber: '',
    statusId: '',
    userTitle: '',
    userType: '',
    roleId: '',
    isAdmin: '',
    addCity: '',
    addState: '',
    addStreet: '',
    addStreetNum: '',
    addZipCode: '',
    birthDate: '',
    codeCountry: '',
    userLogo: '',
    userLogoId: '',
    permissions: '',
    permissionBrokers: '',
    heartbeatDelay: 0,
    notificationList: [],
    notificationActive: true
  })
}

const getDefaultState = () => {
  return {
    name: '',
    userInfos: initUserInfo(),
    permissionList: [],
    config: [],
    brokerList: [],
    functionList: [],
    needToChangePassword: false,
    unreadMessages: 0,
    lastLogin: Storage.getItem('lastLogin', null),
    lastPassword: Storage.getItem('lastPassword', null),
    lastLocale: Storage.getItem('lastLocale', ''),
    userStatusList: [],
    countryList: [],
    contactList: [],
    heartbeatDelay: 0,
    notificationList: [],
    notificationActive: true
  }
}

const state = getDefaultState()

const mutations = {
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERLOGO: (state, avatar) => {
    state.userInfos.userLogo = avatar
  },
  lastLogin: (state, lastLogin) => {
    state.lastLogin = lastLogin
    Storage.setItem('lastLogin', state.lastLogin)
  },
  lastPassword: (state, lastPassword) => {
    state.lastPassword = lastPassword
    Storage.setItem('lastPassword', state.lastPassword)
  },
  needToChangePassword: (state, flag) => {
    state.needToChangePassword = flag
  },
  unreadMessages: (state, count) => {
    state.unreadMessages = count
  },
  userInfos: (state, infos) => {
    let now = new Date()
    if (infos.userId) {
      infos.stationId = infos.userId.toString() + now.getUTCFullYear().toString() + now.getUTCMonth().toString() + now.getUTCDate().toString() + now.getUTCHours().toString() + now.getUTCMinutes().toString() + now.getUTCSeconds().toString()
    }
    for (let item in infos) {
      if (state.userInfos.hasOwnProperty(item)) {
        state.userInfos[item] = infos[item]
      }
    }
    Storage.setItem('userInfos', state.userInfos)
  },
  resetUserInfos: (state, infos) => {
    state.userInfos = infos
    Storage.setItem('userInfos', state.userInfos)
  },
  userStatusList: (state, list) => {
    state.userStatusList = list
  },
  countryList: (state, list) => {
    state.countryList = list
  },
  contactList: (state, list) => {
    state.contactList = list
  },
  SET_FUNCTIONLIST: (state, list) => {
    let arr = []
    if (list.brokerList)       {
      for(let i = 0; i < list.brokerList.length; i++) {
        let idx = arr.findIndex(item => {
          return item && item.brokerId === list.brokerList[i].brokerId
        })
        if (idx === -1) {
          arr.push({
            brokerId: list.brokerList[i].brokerId,
            brokerStatus: list.brokerList[i].brokerStatus,
            brokerName: list.brokerList[i].brokerShortName,
            brokerList: [
              {
                functionId: list.brokerList[i].functionId,
                label: list.brokerList[i].label,
                status: list.brokerList[i].status,
              }
            ]
          })
        }
        else {
          let idx = arr.findIndex(item => {
            return item.brokerId === list.brokerList[i].brokerId
          })
          if (idx !== -1 ) {
            arr[idx].brokerList.push({
              functionId: list.brokerList[i].functionId,
              label: list.brokerList[i].label,
              status: list.brokerList[i].status,
            })
          }
        }
      }
    }
    state.brokerList = arr
    state.functionList = list.functionList || []
  },
  RESET_STORE: (state) => {
    let config = [].concat(state.config)
    Object.assign(state, getDefaultState())
    state.config = config
  },
  SET_CONFIG: (state, data) => {
    state.config = data
    Storage.setItem('config', state.config)
  },
  SET_NOTIFICATIONLIST: (state, notificationList) => {
    if (notificationList)
      state.notificationList = notificationList
  },
  ADD_NOTIFICATION: (state, notification) => {
    if (notification) {
      state.notificationList.unshift(notification)
    }
  },
  SET_NOTIFICATIONACTIVE: (state, notificationActive) => {
    state.notificationActive = notificationActive
  },
  SET_READNOTIFICATION: (state, alertId, isRead) => {
    let idx = state.notificationList.findIndex(item => item.alertId === alertId)
    if (idx !== -1 && state.notificationList[idx]) {
      state.notificationList[idx].isRead = isRead
    }
  },
  SET_READNOTIFICATION_ALL: (state, isRead) => {
    state.notificationList.map(i => { i.isRead = isRead })
  }
}

const actions = {
  login({ commit }, data) {
    data.userInfos.netId = data.netId
    commit('userInfos', data.userInfos)
    commit('unreadMessages', data.unreadMessages || 0)
    commit('SET_NAME', data.userInfos.userFirstName)
    if (data.userStatusList) commit('userStatusList', data.userStatusList || [])
    if (data.countryList) commit('countryList', data.countryList || [])
    if (data.contactList) commit('contactList', data.contactList || [])
    if (data.permissionList) commit('SET_FUNCTIONLIST', data.permissionList)

    store.dispatch('settingsMonitor/getDefaultSettings')
    store.dispatch('tangoEnv/setStatus', 3)
  },

  logout({ dispatch }) {
    return new Promise(async resolve => {
      dispatch('resetStore')
      return resolve()
    }).catch(error => {
      dispatch('resetStore')
      Promise.reject(new Error(error.getMessage()) || 'Error : Logout')
    })
  },

  // remove store
  resetStore({ commit }) {
    return new Promise(resolve => {
      // commit('resetUserInfos', initUserInfo())
      commit('RESET_STORE')
      resetRouter()
      resolve()
    })
  },

  setPermission({ commit }, data) {
    commit('SET_FUNCTIONLIST', data)
  },

  setConfig({ commit }, data) {
    commit('SET_CONFIG', data)
  },

  setNotificationList({ commit }, data) {
    commit('SET_NOTIFICATIONLIST', data)
  },

  addNotification({ commit }, data) {
    commit('ADD_NOTIFICATION', data)
  },

  setNotificationActive({ commit }, data) {
    let active = Boolean(data)
    commit('SET_NOTIFICATIONACTIVE', active)
  },

  setReadNotification({ commit }, alertId, isRead) {
    commit('SET_READNOTIFICATION', alertId, isRead)
  },

  setReadNotificationAll({ commit }, isRead) {
    commit('SET_READNOTIFICATION_ALL', isRead)
  }
  /*
  ChangeRoles({ state, dispatch }, role) {
    return new Promise(async resolve => {
      resetRouter()

      const accessRoutes = await dispatch('permission/generateRoutes', { roles: state.permission, isAdmin: state.envInfos.isAdmin }, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
  */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
